export default "__VITE_ASSET__DZFMwHCr__"